import React from 'react';
import { connect } from 'react-redux';

import AccountGroupSaveConfirmModal from './modals/AccountGroupSaveConfirmModal';
import CompanySaveAndNotifyModal from './modals/CompanySaveAndNotifyModal';
import CompanyDeleteModal from './modals/CompanyDeleteModal';
import { MODALS } from '../constants/Constants';

const isModalOpen = (modals, id) => modals[id] && modals[id].open;

const ModalsContainer = ({ modals }) => {
  return (
    <div>
      {isModalOpen(modals, MODALS.ACCOUNT_GROUP_SAVE_CONFIRM) && <AccountGroupSaveConfirmModal />}
      {isModalOpen(modals, MODALS.COMPANY_SAVE_AND_NOTIFY) && <CompanySaveAndNotifyModal />}
      {isModalOpen(modals, MODALS.COMPANY_DELETE) && <CompanyDeleteModal />}
    </div>
  );
};

const mapStateToProps = ({ modals }) => ({ modals });

export default connect(mapStateToProps)(ModalsContainer);



// WEBPACK FOOTER //
// ./src/containers/ModalsContainer.js